import {useEffect, useRef, useState} from 'react';

import {SurveyStatusResponse} from '../features/company/culture/surveys/types/SurveyQuestionnaireTypes';
import {GetRoutes} from '../lib/api/GET/GetRoutes';
import {SurveyStatus} from '../types/CompanyQuestionnaire';

import {useApiRead} from './useApiRead';

export const useSurveyStatus = (surveyCode?: string | null) => {
  const hasMounted = useRef(false);
  const [status, setStatus] = useState<SurveyStatus>('not-started');
  const {
    data: surveyStatus,
    isLoading,
    error,
  } = useApiRead<SurveyStatusResponse>({
    path: GetRoutes.getSurveyStatus(surveyCode || ''),
    options: {enabled: !!surveyCode},
  });

  useEffect(() => {
    if (!surveyStatus?.companySurvey) return;
    const now = new Date();
    const startedAt = surveyStatus.companySurvey.startedAt ? new Date(surveyStatus.companySurvey.startedAt) : null;
    const endedAt = surveyStatus.companySurvey.endedAt ? new Date(surveyStatus.companySurvey.endedAt) : null;

    if (!startedAt || startedAt > now) setStatus('not-started');
    if (endedAt && endedAt < now) setStatus('ended');
    if (startedAt && startedAt < now) setStatus('active');
    hasMounted.current = true;
  }, [surveyStatus]);

  return {
    status,
    surveyConfiguration: surveyStatus?.companySurvey.configuration,
    isLoading: !hasMounted.current || isLoading,
    error,
  };
};
